import { detailedGroupIcons, generalGroupIcons } from '#features/SidebarTree/OptionGroupMapping'
import GroupIcon from '#icons/folder-32.svg'
import type { TruckConfiguration } from '#store/slices/configurationSlice'

export const getIconForConfigurationStep = (step: TruckConfiguration['step']['system'], index: number) => {
  const iconSet = step === 'GeneralStep' ? generalGroupIcons : detailedGroupIcons
  const iconIndex = Math.max(0, Math.min(index, iconSet.length - 1))
  return iconSet[iconIndex] ?? GroupIcon
}
